import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#E8D5D5] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/9bc45319-956d-4152-8254-f9a19b862440.png"
                alt="Dr.Catch"
                className="h-10 w-auto"
              />
              <span className="text-xl font-semibold tracking-widest text-[#2C2C2C] whitespace-nowrap">Dr.Catch</span>
            </div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-flower-line text-xl text-[#C9A0A0]"></i>
              </div>
            </div>
            <p className="text-[#666666] leading-relaxed">
              医師の隣にいる女が、<br />
              あなたの戦略を作る。
            </p>
          </div>

          {/* Menu Column */}
          <div>
            <h3 className="text-xl font-medium mb-6 text-[#2C2C2C]">Menu</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#4A4A4A] hover:text-[#C9A0A0] transition-colors cursor-pointer">
                  TOP
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-[#4A4A4A] hover:text-[#C9A0A0] transition-colors cursor-pointer">
                  予約
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-[#4A4A4A] hover:text-[#C9A0A0] transition-colors cursor-pointer">
                  書籍案内
                </Link>
              </li>
              <li>
                <Link to="/profile" className="text-[#4A4A4A] hover:text-[#C9A0A0] transition-colors cursor-pointer">
                  プロフィール
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-xl font-medium mb-6 text-[#2C2C2C]">Contact</h3>
            <p className="text-[#4A4A4A] mb-6">info@drcatch.jp</p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-[#C9A0A0] hover:bg-[#C9A0A0] hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-[#C9A0A0] hover:bg-[#C9A0A0] hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#D4A5A5] pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#888888] text-sm">© 2025 Dr.Catch</p>
            <div className="flex flex-wrap justify-center gap-6">
              <Link to="/privacy-policy" className="text-[#888888] text-sm hover:text-[#C9A0A0] transition-colors cursor-pointer">
                プライバシーポリシー
              </Link>
              <Link to="/terms" className="text-[#888888] text-sm hover:text-[#C9A0A0] transition-colors cursor-pointer">
                利用規約
              </Link>
              <Link to="/legal" className="text-[#888888] text-sm hover:text-[#C9A0A0] transition-colors cursor-pointer">
                特定商取引法に基づく表記
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}